import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getDevData, patchData } from "../../services/generalService";
import { BillsObj } from "../../utils/types";

const initialState: BillsObj = {
  data: null,
  isLoading: true,
  isSuccess: false,
  isError: false,
};

export const getAllBillsData = createAsyncThunk(
  "getAllBills",
  async (url: string, thunkAPI) => {
    try {
      const data = await getDevData(url);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

export const updateBillData = createAsyncThunk(
  "updateBillData",
  async (pData: { url: string; data: any }, thunkAPI) => {
    try {
      const data = await patchData(pData.url, pData.data);
      return data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response);
    }
  }
);

const billsSlice = createSlice({
  name: "bills",
  initialState,
  reducers: {
    // synchronous aperations goes here
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBillsData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllBillsData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getAllBillsData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      })
      .addCase(updateBillData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBillData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
      })
      .addCase(updateBillData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.data = null;
      });
  },
});

export default billsSlice.reducer;
